export const sharpen = (num: number) =>
  num % 1 < 0.5 ? Math.floor(num / 0.5) * 0.5 + 0.5 : Math.floor(num / 0.5) * 0.5;
